import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Icon } from 'semantic-ui-react'
import DataTable from '../datatable'
import Edit from './edit'

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    id: true,
    render(item) {
      let icon = item.getIn(['data', 'icon'])
      return (
        <span>
          {icon ? <Icon name={icon} /> : null}
          {item.get('name')}
        </span>
      )
    },
  },
  {
    name: 'data.info',
    label: 'Info',
  },
  {
    name: 'versions',
    label: 'Kieliversiot',
    render(i) {
      return <div>{i.get('templates', Map()).keySeq().join(' / ')}</div>
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
]

export default function TaskTypeRoot() {
  return (
    <DataTable
      id="messageTemplates"
      entity="message_template"
      crud
      title="Viestipohjat"
      texts={{ createButton: 'Lisää viestipohja' }}
      editComponent={Edit}
      columns={columns}
    />
  )
}
